import React from "react";
import { Modal } from 'react-bootstrap';

export default function Intervention({ data, close }) {
    const start = data?.date?.dateStart ? new Date(data.date.dateStart) : null;
    const end = data?.date?.dateEnd ? new Date(data.date.dateEnd) : null;
    const duration = data?.date?.duration;
    const property = data?.property;

    return (
        <Modal show={!!start} onHide={close} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        <span className="badge badge-warning" style={{ width: 'fit-content' }}>
                            Intervention
                        </span>
                        <span>Détails de l'intervention</span>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="event-details intervention-details">
                    {start && (
                        <div className="event-detail-row">
                            <div className="event-detail-icon">
                                <i className="fas fa-calendar-alt" />
                            </div>
                            <div className="event-detail-content">
                                <span className="event-detail-label">Début</span>
                                <span className="event-detail-value">{formatDateTime(start)}</span>
                            </div>
                        </div>
                    )}

                    {(end || duration) && (
                        <div className="event-detail-row">
                            <div className="event-detail-icon">
                                <i className="fas fa-clock" />
                            </div>
                            <div className="event-detail-content">
                                <span className="event-detail-label">Fin / Durée</span>
                                <span className="event-detail-value">
                                    {end ? formatDateTime(end) : `Durée : ${duration}`}
                                </span>
                            </div>
                        </div>
                    )}

                    {property && (
                        <div className="event-detail-row">
                            <div className="event-detail-icon">
                                <i className="fas fa-home" />
                            </div>
                            <div className="event-detail-content">
                                <span className="event-detail-label">Propriété</span>
                                <span className="event-detail-value">{property}</span>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={close}>
                    Fermer
                </button>
            </Modal.Footer>

            <style>{`
                .intervention-details {
                    display: flex;
                    flex-direction: column;
                    gap: 14px;
                }

                .intervention-details .event-detail-row {
                    display: flex;
                    align-items: flex-start;
                    gap: 14px;
                    padding: 14px;
                    background: #f8f9fa;
                    border-radius: 12px;
                }

                .intervention-details .event-detail-icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #fff;
                    border-radius: 10px;
                    color: #003952;
                    flex-shrink: 0;
                }

                .intervention-details .event-detail-content {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    min-width: 0;
                }

                .intervention-details .event-detail-label {
                    font-size: 0.75rem;
                    font-weight: 600;
                    color: #71717a;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }

                .intervention-details .event-detail-value {
                    font-size: 0.95rem;
                    color: #18181b;
                    font-weight: 500;
                    line-height: 1.4;
                }

                .intervention-details .event-detail-value--multiline {
                    white-space: pre-wrap;
                }
            `}</style>
        </Modal>
    );
}

function formatDateTime(date) {
    return date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

